// extracted by mini-css-extract-plugin
module.exports = {"work_section":"WorkSectionStyle-module--work_section--ubUkI","holder":"WorkSectionStyle-module--holder--3mDyO"};